import { ADD_TASK, REMOVE_TASK, UPDATE_TASK } from '../types/smartFlowConstants'

export function addTask(item) {
  return {
    type: ADD_TASK,
    payload: item
  }
}

export function removeTask(item) {
  return {
    type: REMOVE_TASK,
    payload: item
  }
}

export function updateTask(item) {
  return {
    type: UPDATE_TASK,
    payload: item
  }
}
